import withChildrenOrderCheck from '../../utils/withChildrenOrderCheck';
import { Dropdown, IDropdownProps } from './Dropdown';
export { List } from './components/List';
export { Footer } from './components/Footer';

const componentToExport =
  process.env.NODE_ENV === 'production'
    ? Dropdown
    : withChildrenOrderCheck<IDropdownProps & { children: React.ReactNode }>(
        Dropdown,
        {
          List: 1,
          Footer: 2,
        },
      );

export default componentToExport;
